import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import * as React from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";
import { TurnstileWidget } from "@/components/TurnstileWidget";
import { useTurnstile } from "@/hooks/useTurnstile";
import { useTranslation } from "@/hooks/useTranslation";
import { DonationAmountConfirmation } from "./DonationAmountConfirmation";

type FormStepConfirmDetailsProps = {
  onStepSubmit: () => void;
  message: string | React.ReactNode;
  hideSubmitButton?: boolean;
};

export function FormStepConfirmDetails(props: FormStepConfirmDetailsProps) {
  const { onStepSubmit, message, hideSubmitButton = false } = props;
  const t = useTranslation("_common");
  const { isReady } = useTurnstile();

  const handleSubmit = () => {
    onStepSubmit();
    dispatchEvent(EventName.STEP_SUBMIT, {
      step_name: DetailsStep.ConfirmDetails,
      data: {},
    });
  };

  return (
    <div>
      <div className={classes.confirmMessage}>{message}</div>

      <DonationAmountConfirmation />
      <TurnstileWidget />

      {!hideSubmitButton && (
        <div className={classes.pagination}>
          <Button size="large" disabled={!isReady} onClick={handleSubmit}>
            {t("complete-donation")}
          </Button>
        </div>
      )}
    </div>
  );
}
